<template>
  <v-flex xs12>
    <v-container v-if="loading" grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <looping-rhombuses-spinner
            style="margin: auto;"
            class="text-xs-center"
            :animation-duration="1000"
            :size="80"
            color="#1976d2"
          />
          <h3 style="color: #555;" class="pt-4">Loading Balance Operations</h3>
        </v-flex>
      </v-layout>
    </v-container>
    <template v-else>
      <v-layout row v-if="balanceOperations.length === 0" justify-center ma-5>
        <span class="caption pl-4">
          <v-icon color="primary" small class="pr-2">info</v-icon>There is no
          entries in the history yet.
        </span>
      </v-layout>

      <v-card class="mb-4" v-for="(operation, i) in balanceOperations" :key="i">
        <reconciliationShow
          :showCompanyBalance="true"
          :bankReconciliation="operation.bank_reconciliation"
        />
      </v-card>
    </template>
    <v-layout justify-center>
      <v-btn
        color="primary"
        class="white--text"
        depressed
        small
        v-if="balanceOperations.length < historyTotalCount && !loading"
        @click="loadMore()"
        >Load More</v-btn
      >
    </v-layout>
  </v-flex>
</template>
<script>
import reconciliationShow from "./reconciliationShow";
import currency from "../../../mixins/currency.js";
import PAGINATED_BALANCE_OPERATIONS from "../../../graphql/balance_operations/paginated_index.gql";
import { LoopingRhombusesSpinner } from "epic-spinners";
import accountingStatus from "../../../mixins/accountingStatus.js";

export default {
  data() {
    return {
      balanceOperations: [],
      loading: true,
      historyPage: 1,
      historyTotalCount: -1,
    };
  },
  mixins: [accountingStatus, currency],
  components: {
    reconciliationShow,
    LoopingRhombusesSpinner,
  },
  props: {
    companyBalanceId: {
      type: String,
      required: true,
    },
  },
  methods: {
    loadMore() {
      this.historyPage += 1;
      this.fetchBalanceOperations();
    },
    fetchBalanceOperations() {
      this.sendQuery(PAGINATED_BALANCE_OPERATIONS, {
        page: this.historyPage,
        per_page: 5,
        order_by: "created_at DESC",
        filter: `company_balance_id == '${this.companyBalanceId}'`,
      })
        .then((data) => {
          this.loading = false;
          this.historyTotalCount =
            data.paginated_balance_operations.total_count;
          this.balanceOperations = this.balanceOperations.concat(
            data.paginated_balance_operations.data
          );
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchBalanceOperations();
  },
  watch: {
    companyBalanceId() {
      this.balanceOperations = [];
      this.fetchBalanceOperations();
    },
  },
};
</script>
